import src from "IMAGE";
export default { src, width: 158, height: 40, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AA4qRmUbUYjIFDtijxhIeLMVP2qZGkx/vRlKfLcZSny7ABdDcKEbUIfGGkyAuxpOg8IVPmiXG1CFxxpMf7gaToO/83kYVWvSK60AAAAASUVORK5CYII="};
